import ImageGallery from './ImageGallery';
import ImageDescription from './Components/ImageDescription/ImageDescription';

export { ImageDescription };
export default ImageGallery;
